import { cn, Image } from '@ds';
import { Link } from 'react-router-dom';
import { getColorsByOrganType, getOrganImg } from '@/utils/helpers';
import { OrganType, DonorType } from '@/api/apis/case';
import { Uuid } from '@/api/types';

type BulkAssignmentCaseCellProps = {
  caseId: Uuid;
  caseName: string;
  organType: OrganType;
  donorType: DonorType;
};

export const BulkAssignmentCaseCell = ({ caseId, caseName, organType, donorType }: BulkAssignmentCaseCellProps) => {
  const colors = getColorsByOrganType(organType);
  return (
    <div className="flex gap-2 items-center">
      <div className={cn('rounded-full p-1', colors.bg60)}>
        <Image src={getOrganImg(organType)} alt={`${organType} image`} />
      </div>
      <div>
        <div className="text-m-m">
          <Link
            to={`/case/${caseId}`}
            onPointerDown={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            target="_blank"
            className="hover:underline text-inherit"
          >
            {caseName}
          </Link>
        </div>
        <div className={cn('text-s-m', colors.textDefault)}>{donorType}</div>
      </div>
    </div>
  );
};
